import type { VideoEntry, SoundState, Winner } from './types';

export const SETTLE_MS = 150;
export const RATIO_THRESHOLDS = [0, 0.25, 0.5, 0.75, 1];

export const electWinner = (entries: Map<string, VideoEntry>): Winner => {
    let winner: Winner = { id: null, sharesPlayback: false };
    let bestRatio = 0;
    entries.forEach((entry, id) => {
        if (entry.isPlaybackCandidate && entry.ratio > bestRatio) {
            bestRatio = entry.ratio;
            winner = { id, group: entry.playbackGroup, sharesPlayback: entry.sharesPlayback };
        }
    });
    return winner;
};

/**
 * Group-scoped so a second carousel on the same page never joins this one. The group must be
 * defined, otherwise two ungrouped sharers would match on `undefined === undefined`.
 */
export const joinsWinner = (entry: VideoEntry, winner: Winner) =>
    winner.sharesPlayback &&
    winner.group !== undefined &&
    entry.sharesPlayback &&
    entry.playbackGroup === winner.group &&
    entry.ratio > 0;

/** Falls back to the winner so audio follows the user; returns `current` so React can bail out. */
export const withOwner = (current: SoundState, playingIds: Set<string>, winnerId: string | null): SoundState => {
    const ownerId = current.ownerId && playingIds.has(current.ownerId) ? current.ownerId : winnerId;
    return ownerId === current.ownerId ? current : { ...current, ownerId };
};

/**
 * A playing video can always take sound. A paused one only can when nothing else is playing —
 * otherwise it would silence the page. Reachable because animated-trailer and post-launch sound
 * buttons stay clickable while paused.
 */
export const shouldClaimSound = (entries: Map<string, VideoEntry>, id: string) =>
    entries.get(id)?.playing || ![...entries.values()].some((entry) => entry.playing);
